import Api from '../http.service';

/**
 * get last wallet transaction list
 * @param {Object} payload
 * @param {Number} payload.pointAmount
 */
export const fetchPointWageList = (payload) =>
  Api.POST({
    url: `point_rules/transaction_wage`,
    data: payload,
  });
